<template>
    <div>
        <template v-if="crud_employee === true && crud_employee !==null">
            <form id="employeeForm" @submit.prevent="uploadImage" enctype="multipart/form-data">
                <div class="page-top mb-1 mb-3 clearfix">
                    <h1 class="float-left"> Add Employee </h1>
                    <button :disabled="form.busy" class="btn btn-primary float-right submit_form">Next</button>
                    <router-link to="/employees" class="btn btn-primary float-right mr-1"> Cancel </router-link>
                </div>
                <div class="peopple-managment-main">
                    <ul class="page-status">
                        <li class="page-status-list active">
                            <span class="status-highlighter">1</span>
                            Personal Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">2</span>
                            Job Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">3</span>
                            Tax Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">4</span>
                            Payment Details
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">5</span>
                            Time Off
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">6</span>
                            User Permission
                        </li>
                        <li class="page-status-list">
                            <span class="status-highlighter">7</span>
                            Welcome Options
                        </li>
                    </ul>
                    <div class="people-management-inner-content p-5">
                        <div class="update-profile">
                            <div class="form-group upload-img-inner">
                                <div class="user-image">
                                    <div v-if="form.image_url == null" id="image-preview" class="user-image-holder" :style="'background: url('+this.$global.base_url+'images/table-dummy-image.jpg); '">
                                        <input type="file" accept="image/*" name="image" id="image-upload" v-on:change="onImageChange">
                                    </div>
                                    <div v-else id="image-preview" class="user-image-holder" :style="'background: url('+preview+');'">
                                        <input type="file" accept="image/*" name="image" id="image-upload" v-on:change="onImageChange">
                                    </div>
                                    <div class="user-images-detail">
                                        <label for="image-upload" id="image-label"> Add photo </label>
                                        <span> ( 100 X 100 ) </span>
                                        <p> Profile Picture <small> (Optional) </small> </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Full Name <em class="required">*</em> </label>
                                    <input v-model="form.name" type="text" name="name" autocomplete="off" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }" maxlength="30">
                                    <has-error :form="form" field="name"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Mobile Number  <em class="required">*</em> </label>
                                    <input v-model="form.mobile_no" type="text" @keypress="isNumber($event)" name="mobile_no" autocomplete="off" class="form-control" :class="{ 'is-invalid': form.errors.has('mobile_no') }" placeholder="92XXXXXXXXXX" maxlength="12">
                                    <has-error :form="form" field="mobile_no"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Father's Name </label>
                                    <input v-model="form.father_name" type="text" name="father_name" autocomplete="off" class="form-control" :class="{ 'is-invalid': form.errors.has('father_name') }">
                                    <has-error :form="form" field="father_name"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Date Of Birth </label>
                                    <datepicker name="dob" v-model="form.dob" input-class="datepicker" autocomplete="off" :class="{ 'is-invalid': form.errors.has('dob') }" :bootstrap-styling="true" :clear-button="true"></datepicker>
                                    <has-error :form="form" field="dob"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> CNIC <em class="required">*</em> </label>
                                    <input v-model="form.cnic" type="text" name="cnic" maxlength="13" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('cnic') }">
                                    <has-error :form="form" field="cnic"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Home Address </label>
                                    <input v-model="form.current_address" type="text" name="current_address" class="form-control" autocomplete="off" :class="{ 'is-invalid': form.errors.has('current_address') }">
                                    <has-error :form="form" field="current_address"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Gender <em class="required">*</em> </label>
                                    <select v-model="form.gender" name="gender" autocomplete="off" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('gender') }">
                                        <option value="" selected>Gender</option>
                                        <option value="MALE">Male</option>
                                        <option value="FEMALE">Female</option>
                                    </select>
                                    <has-error :form="form" field="gender"></has-error>
                                </div>
                            </div>
                        </div>
                        <h2 class="subhead inner-head mb-3"> Emergency Contact </h2>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Full Name  </label>
                                    <input v-model="form.contact_person_name" type="text" name="contact_person_name" autocomplete="off" class="form-control" :class="{ 'is-invalid': form.errors.has('contact_person_name') }">
                                    <has-error :form="form" field="contact_person_name"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Relationship </label>
                                    <input v-model="form.contact_person_relation" type="text" name="contact_person_relation" autocomplete="off" class="form-control" :class="{ 'is-invalid': form.errors.has('contact_person_relation') }">
                                    <has-error :form="form" field="contact_person_relation"></has-error>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Mobile Number   </label>
                                    <input v-model="form.contact_person_mobile_no" @keypress="isNumber($event)" type="text" name="contact_mobile_no" autocomplete="off" class="form-control" :class="{ 'is-invalid': form.errors.has('contact_mobile_no') }" maxlength="12">
                                    <has-error :form="form" field="contact_mobile_no"></has-error>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="label block-label"> Email </label>
                                    <input v-model="form.contact_person_email" type="email" name="contact_person_email" autocomplete="off" class="form-control" :class="{ 'is-invalid': form.errors.has('contact_person_email') }">
                                    <has-error :form="form" field="contact_person_email"></has-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </template>
        <template v-else-if="crud_employee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="crud_employee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    image_url : '',
                    name : '',
                    mobile_no : '',
                    father_name : '',
                    dob : '',
                    cnic : '',
                    current_address : '',
                    gender : '',
                    password : 'Temp@123',
                    contact_person_name : '',
                    contact_person_relation : '',
                    contact_person_mobile_no : '',
                    contact_person_email : '',
                    id : this.$route.params.id
                }),
                crud_employee: null,
                preview: null
            }
        },
        methods: {
            addEmployeePersonalDetail() {
                this.$Progress.start();
                this.form.post('/api/addEmployeePersonalDetail')
                .then(res => {
                    if(res.status == 200){
                        if(res.data.status == 200){
                            this.$Progress.finish();
                            this.showToastBox('success', 'Employee personal detail added successfully');
                            this.$router.push('/addEmployeeBasicDetail/'+res.data.data.id);
                        }else if(res.data.status == 400){
                            this.$Progress.fail();
                            this.showAlertBox('error',res.data.msg);
                        }else{
                            this.$Progress.fail();
                        }
                    }else{
                        this.$Progress.fail();
                    }
                })
                .catch(err => {
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
            getEmployeeData() {
                axios.get('/api/editEmployee/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        if(res.data.page_view == false){
                            this.crud_employee = false;
                        }else if(res.data.page_view == true){
                            if(res.data.user.wizard_cycle == 0){
                                this.form.name = res.data.user.name;
                                this.form.mobile_no = res.data.user.mobile_no;
                                this.form.father_name = res.data.user.father_name;
                                this.form.dob = res.data.user.dob;
                                this.form.cnic = res.data.user.cnic;
                                this.form.current_address = res.data.user.current_address;
                                this.form.gender = res.data.user.gender;
                                this.form.contact_person_name = res.data.user.contact_name;
                                this.form.contact_person_relation = res.data.user.contact_relation;
                                this.form.contact_person_mobile_no = res.data.user.contact_number;
                                this.form.contact_person_email = res.data.user.contact_email;
                            }else if(res.data.user.wizard_cycle == 1){
                                this.$router.push('/addEmployeeBasicDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 2){
                                this.$router.push('/addEmployeeTaxDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 3){
                                this.$router.push('/addEmployeePaymentDetail/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 4){
                                this.$router.push('/addEmployeeTimeoff/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 5){
                                this.$router.push('/addEmployeeUserPermission/'+this.$route.params.id);
                            }else if(res.data.user.wizard_cycle == 6){
                                this.$router.push('/addEmployeeWelcome/'+this.$route.params.id);
                            }
                        }
                    }else{
                        this.showAlertBox('error','Error to load data');
                    }
                })
                .catch(err => {
                    this.showAlertBox('error','Error to load data');
                });
            },
            // onImageChange(e){
            //     const file = e.target.files[0];
            //     this.form.image_url = URL.createObjectURL(file);
            // },
            onImageChange(e) {
                let self=this;
                var files = e.target.files || e.dataTransfer.files;
                if(files.length >0){
                    this.form.image_url=e.target.files[0];
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        self.preview=e.target.result;
                    }
                    reader.readAsDataURL(e.target.files[0]);
                }else{
                    this.form.image_url='';
                }
            },
            uploadImage(){
                this.$Progress.start();
                if(this.form.image_url !=""){
                    let form=new FormData();
                    form.append('image_url',this.form.image_url);   
    
                    axios.post('/api/saveImage',form)
                    .then(res => {
                        if(res.status == 200){
                            this.form.image_url = res.data.image_url;
                            this.addEmployeePersonalDetail();
                        }
                    })
                    .catch(err => {
                        this.$Progress.fail();
                    });
                }else{
                    this.addEmployeePersonalDetail();
                }       
            },
        },
        mounted() {
            this.$Progress.start();
            this.can('crud_employee').then(result => {
                this.crud_employee = result.crud_employee;
            }).then(result => {
                if(this.crud_employee == true){
                    if(this.$route.params.id != null){
                        this.getEmployeeData();
                    }
                    $(this.$el).find('.selectpicker').selectpicker('refresh');
                    this.$Progress.finish();
                }
            });
        }
    }
</script>
